var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21.85 25.94",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e1dfba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M15.15,25.94c-.63-.43-1.27-.84-1.88-1.29a1.75,1.75,0,0,1-.56-.68c-1.36-3.19-2.69-6.38-4-9.57a5.5,5.5,0,0,0-.24-.51L6.55,15c-1.5.89-3,1.77-4.5,2.67a.59.59,0,0,1-.77,0c-.43-.31-1.15-.5-1.26-.89s.34-.95.58-1.43C2.47,11.65,4.33,8,6.22,4.25a1.71,1.71,0,0,1,.6-.65C8.86,2.39,10.91,1.2,13,0h.23c.48.28.94.58,1.43.83a1.29,1.29,0,0,1,.69.85c.57,1.79,1.16,3.56,1.76,5.34a.61.61,0,0,1-.26.81,4,4,0,0,0-1.56,4.62,4.11,4.11,0,0,0,4,2.84.55.55,0,0,1,.65.46q.9,2.84,1.86,5.66a.59.59,0,0,1-.32.83c-2,1.22-4.06,2.46-6.09,3.7ZM6.69,4.31.45,16.66l1.14.67L7.18,9.75c.19.4.33.64.44.9,1.73,4.15,3.51,8.28,5.17,12.45a4,4,0,0,0,2,2l-.08-.29Q11.54,15.13,8.36,5.49a.69.69,0,0,0-.23-.37C7.68,4.84,7.2,4.59,6.69,4.31ZM7.07,4a8.2,8.2,0,0,1,.72.42,1,1,0,0,0,1.33,0,10.77,10.77,0,0,1,1.18-.7c1.37-.78,2.73-1.57,4.17-2.41C14,1,13.67.81,13.29.64a.59.59,0,0,0-.47,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.13,13.73a2.55,2.55,0,1,1,2.57-2.54A2.58,2.58,0,0,1,19.13,13.73Zm0-4.62a1.94,1.94,0,0,0-1.85,1.05,1.9,1.9,0,0,0,0,2.07.87.87,0,0,0,.62.36,3,3,0,0,0,2.54-1.45c.85-1.25.19-1.67-1-2A1.28,1.28,0,0,0,19.12,9.11Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpo);
export default __webpack_public_path__ + "static/media/expo.124b076e235af8e3f454a8b5a687c6b5.svg";
export { ForwardRef as ReactComponent };